import { toString } from 'lodash/fp';
import type { ReactNode } from 'react';
import type { TableColumn } from './types';
import { Row } from './Row';

export interface BodyProps<TRow> {
    columns: TableColumn<TRow>[];
    rows: TRow[];
    rowKey: keyof TRow;
    selectedRow?: string | number;
    onSelectRow?: (rowKey: unknown) => void;
    menuRenderer?: (row: TRow) => ReactNode;
    detailsKey?: keyof TRow;
    detailsRenderer?: (value: unknown) => ReactNode;
    stickyIfExpanded?: boolean;
    rowClassName?: (row: TRow) => string;
    width?: number;
}

export function Body<TRow>({
    columns,
    rows,
    rowKey,
    selectedRow,
    onSelectRow,
    menuRenderer,
    detailsKey,
    detailsRenderer,
    stickyIfExpanded = false,
    rowClassName,
    width
}: BodyProps<TRow>) {
    return (
        <tbody>
            {rows.map((row) => (
                <Row
                    key={toString(row[rowKey])}
                    rowClassName={rowClassName}
                    columns={columns}
                    row={row}
                    selected={row[rowKey] === selectedRow}
                    rowKey={rowKey}
                    detailsKey={detailsKey}
                    detailsRenderer={detailsRenderer}
                    menuRenderer={menuRenderer}
                    onSelectRow={onSelectRow}
                    stickyIfExpanded={stickyIfExpanded}
                    width={width}
                />
            ))}
        </tbody>
    );
}
